<script>
export default {
  render() {
    return null;
  },
};
</script>
